import React, { useEffect, useMemo, useState } from "react";
import Popup from 'reactjs-popup';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import styles from './ModalDetails.module.scss';
import { DataLayerAPI } from "../../../api/DataLayerAPI";
import { OffersType } from "../../../types/SpecialOfferType";
import { OffersAPI } from "../../../api/OffersAPI";
import { getEnv } from "../../../utils/getEnv";
import ReactHtmlParser from 'react-html-parser'


type ModalDetailsProps = {
    trigger: JSX.Element,
};

export function ModalDeatils({ trigger }: ModalDetailsProps) {

    const dataLayerAPI = new DataLayerAPI()
    const offersAPI = useMemo(() => new OffersAPI(process.env.NEXT_PUBLIC_API_BASE_URL ?? ''), [])

    const env = getEnv()
    const [ renderPopup, setRenderPopup ] = useState(false);
    const [ offers, setOffers ] = useState<OffersType>()

    useEffect(() => setRenderPopup(true), [setRenderPopup]);
    useEffect(() => {
      let specialOfferID = '297551';
      if(env === 'dev' || env === 'staging') specialOfferID  = '294360'

      async function getOffers() {
        const result = await offersAPI.get(specialOfferID);
        setOffers(result);
      }
      getOffers()
    }, [offersAPI,env])

    return renderPopup ? (
        <Popup trigger={trigger} modal lockScroll onOpen={() => dataLayerAPI.logModalAction('Modal Opened','Express Passess Included','View Deatils | Express Passess Included')} onClose={() => dataLayerAPI.logModalAction('Modal Closed','Express Passess Included','View Deatils | Express Passess Included')}>
            {(close: Function) => (
                <div className={styles.modal}>
                    <Tabs>
                        <TabList>
                            <Tab><a>HIGHLIGHTS</a></Tab>
                        </TabList>
                        <TabPanel className='scroll'>
                        <button className={styles.close} onClick={() => close()}>
                                <span className='visuallyHidden'>Close</span>
                            </button>
                            {offers ?
                                <>
                                  <h1>{offers.title}</h1>
                                  <h3>{offers.short_desc}</h3>
                                  { ReactHtmlParser(offers.intro)}
                                </>
                                :  <div className='loading mh100'></div>
                                }
                        </TabPanel>
                    </Tabs>
                </div>
            )}
        </Popup>
    ) : null;
}
